import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_document",
  "use": "micro_document-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_document\"><path d=\"M6 0v4h4v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h5Zm2 6H2v1h6V6ZM4 3H2v1h2V3Zm3-3 3 3H7V0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol